import { useCallback, useRef } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const mediaUrl = (u) => (!u ? "" : u.startsWith("/api") ? `${BACKEND_URL}${u}` : u);
export const errMsg = (e) => e?.response?.data?.detail?.toString?.() || "Algo salió mal. Inténtalo de nuevo.";

export function useApi() {
  const { getToken } = useAuth();
  const ref = useRef(getToken);
  ref.current = getToken;
  return useCallback(async (method, url, data, config = {}) => {
    const token = await ref.current();
    const res = await axios({
      method, url: `${API}${url}`, data, ...config,
      headers: { ...(config.headers || {}), ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    });
    return res.data;
  }, []);
}

export const STATUS_LABELS = {
  none: "Sin postular", pending: "En revisión", approved: "Sonando en la radio", rejected: "Rechazada",
  aired: "Emitida", not_aired: "No emitida", refunded: "Créditos devueltos",
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("es-AR", { day: "2-digit", month: "short", year: "numeric" }) : "—");
